import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Carlos M.',
    role: 'Consultor de Marketing',
    text: 'Antes pasaba 4 horas al día moviendo leads de Facebook a mi CRM. Con el Tomo 2 y los blueprints, automaticé todo en una tarde. Ya cerré mi primer cliente de mantenimiento por $300/mes.',
    image: 'https://i.pravatar.cc/150?img=11'
  }, {
    name: 'David R.',
    role: 'Agencia Digital',
    text: "El Tomo 4 sobre cómo vender esto es oro puro. Pasé de vender webs a vender 'sistemas operativos' para negocios. Mis tickets se triplicaron.",
    image: 'https://i.pravatar.cc/150?img=33'
  }, {
    name: 'Andrés V.',
    role: 'Freelancer',
    text: 'No sabía nada de código. n8n me asustaba, pero la forma en que explica la lógica de nodos es brutal. Los 80 JSONs de regalo valen 10 veces lo que pagué.',
    image: 'https://i.pravatar.cc/150?img=53'
  }, {
    name: 'Javier L.',
    role: 'E-commerce Manager',
    text: 'Implementé el chatbot de WhatsApp con IA del bonus. Las ventas automáticas subieron un 40% el primer mes. Increíble material.',
    image: 'https://i.pravatar.cc/150?img=15'
  }, {
    name: 'Miguel A.',
    role: 'Desarrollador Web',
    text: 'Incluso sabiendo programar, este libro me enseñó a armar flujos 10x más rápido. El enfoque en negocio y no solo técnico es lo que hace la diferencia.',
    image: 'https://i.pravatar.cc/150?img=60'
  }];
  return <section className="py-20 bg-gray-50 px-4" data-id="element-196">
      <div className="max-w-6xl mx-auto" data-id="element-197">
        <div className="text-center mb-16" data-id="element-198">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-199">
            Resultados Reales de{' '}
            <span className="text-brand-red" data-id="element-200">Arquitectos No-Code</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-201">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 flex flex-col" data-id="element-202">
              <div className="flex gap-1 mb-4" data-id="element-203">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-yellow text-brand-yellow" data-id="element-204" />)}
              </div>
              <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-205">"{t.text}"</p>
              <div className="flex items-center gap-4 mt-auto pt-4 border-t border-gray-100" data-id="element-206">
                <img src={t.image} alt={t.name} className="w-12 h-12 rounded-full object-cover" data-id="element-207" />
                <div data-id="element-208">
                  <p className="font-bold text-gray-900" data-id="element-209">{t.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-210">{t.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}